/**
 * Get the customer app base URL based on environment
 * Auto-detects staging vs production based on current hostname
 * Handles custom domains by using environment variable or defaulting to staging
 */
export const getCustomerBaseUrl = () => {
  // If explicitly set via env var, use that
  if (process.env.REACT_APP_CUSTOMER_URL || process.env.REACT_APP_CUSTOMER_BASE_URL) {
    return process.env.REACT_APP_CUSTOMER_URL || process.env.REACT_APP_CUSTOMER_BASE_URL;
  }

  // Auto-detect from current hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;

    // Development environment
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:3001';
    }

    // Check for staging environment (platform subdomain)
    if (hostname.includes('staging.userevstar.com')) {
      return 'https://my.staging.userevstar.com';
    }

    // Check for production (userevstar.com but not staging)
    if (hostname.includes('userevstar.com') && !hostname.includes('staging')) {
      return 'https://my.userevstar.com';
    }

    // Check for Vercel preview deployments
    if (hostname.includes('vercel.app')) {
      // Try to construct customer app URL from current deployment
      const match = hostname.match(/^([^.]+)-/);
      if (match) {
        return `https://${match[1]}-customer.vercel.app`;
      }
      // Fallback for Vercel - use configured customer app or live customer app.
      return process.env.REACT_APP_CUSTOMER_URL || process.env.REACT_APP_CUSTOMER_BASE_URL || 'https://my.userevstar.com';
    }

    // Custom domain detected (not localhost, not userevstar.com, not vercel.app)
    // Custom domains are typically used in production, so default to production customer app
    console.log('[customerBase] Custom domain detected:', hostname);
    console.log('[customerBase] Redirecting to production customer app for authentication');

    // Custom domains = production environment
    return process.env.REACT_APP_CUSTOMER_URL || 'https://my.userevstar.com';
  }

  // Fallback to production for SSR or unknown environments
  return 'https://my.userevstar.com';
};
